var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.4447L24.7376 13.7071C25.1281 13.3166 25.7613 13.3166 26.1518 13.7071L26.2929 13.8482C26.6834 14.2387 26.6834 14.8719 26.2929 15.2624L21.5553 20L26.2929 24.7376C26.6834 25.1281 26.6834 25.7613 26.2929 26.1518L26.1518 26.2929C25.7613 26.6834 25.1281 26.6834 24.7376 26.2929L20 21.5553L15.2624 26.2929C14.8719 26.6834 14.2387 26.6834 13.8482 26.2929L13.7071 26.1518C13.3166 25.7613 13.3166 25.1281 13.7071 24.7376L18.4447 20L13.7071 15.2624C13.3166 14.8719 13.3166 14.2387 13.7071 13.8482L13.8482 13.7071C14.2387 13.3166 14.8719 13.3166 15.2624 13.7071L20 18.4447Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e85db7a3c212bef7c4f667597ea5e494.svg";
export { ForwardRef as ReactComponent };